import instance from "../../config/interceptor";
import { BASE_API_URL } from "../../config/api";

export const getCredential = async () => {
  let _response;
  try {
    const response = await instance.get(
      `${BASE_API_URL}/dashboard/satu-sehat/integration`
    );
    _response = response;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};

export const postCredential = async (data) => {
  let _response;
  try {
    const response = await instance.post(
      `${BASE_API_URL}/dashboard/satu-sehat/integration`,
      data
    );
    _response = response;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};
